import * as React from "react";
import ExternalLink from "../ExternalLink";
import { repository, session } from "clientInstance";
import Divider from "components/Divider/Divider";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent/DataBaseComponent";
import ErrorPanel from "components/ErrorPanel/ErrorPanel";
import {default as Callout, CalloutType} from "components/Callout/Callout";

const styles = require("./style.less");

interface SystemMessagesBannerState extends DataBaseComponentState {
    isInMaintenanceMode: boolean;
    browserNotSupported: boolean;
    browserName: string;
}

export default class SystemMessagesBanner extends DataBaseComponent<{}, SystemMessagesBannerState> {

    constructor(props: {}) {
        super(props);

        let browserNotSupported = false;
        let browserName = "";

        const ieVersion = (document as any)["documentMode"];
        if (ieVersion && ieVersion <= 10) {
            browserNotSupported = true;
            browserName = "Internet Explorer " + ieVersion;
        }

        this.state = {
            isInMaintenanceMode: false,
            browserNotSupported,
            browserName
        };
    }

    async componentDidMount() {
        await this.beginRefreshLoop(() => this.refreshData(), 10000);
    }

    async refreshData() {
        const status = await repository.ServerStatus.getServerStatus();
        return { isInMaintenanceMode: status.IsInMaintenanceMode };
    }

    render() {
        return <div className={styles.pageBanners}>
            {this.state.isInMaintenanceMode && <Callout type={CalloutType.Warning}>
                <p className={styles.warning}>This Octopus Server is currently undergoing maintenance, and is read-only. Only Octopus
                    administrators may make changes.</p>
            </Callout>}
            {this.state.errors && <ErrorPanel message={this.state.errors.message} details={this.state.errors.details}/>}
            {this.state.isInMaintenanceMode && this.state.browserNotSupported && <Divider/>}
            {this.state.browserNotSupported && <Callout type={CalloutType.Warning}>
                <p className={styles.warning}>
                    Your current browser, <strong>{this.state.browserName}</strong>, is not supported in <strong>Octopus
                    4</strong>.
                    We still allow you to use Octopus but no guarantee that everything works!<br/>
                    If you have any questions or feedback then please share them with us <strong>
                    <ExternalLink
                        href="https://github.com/OctopusDeploy/Issues/issues/3457">here</ExternalLink></strong>.
                </p>
            </Callout>}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/SystemMessagesBanner/SystemMessagesBanner.tsx